'use strict';

/**
 * @ngdoc function
 * @name courseApp.controller:CheckinController
 * @description
 * # CheckinController
 * Controller of the courseApp
 */
angular.module('courseApp')
    .controller('CheckinController', function (BasicService, ActCourseService, APIs, ConfigService) {
        var vm = this;
        vm.selectedAttendee = undefined;
        vm.showAttendeePrice = false;

        vm.selectedCourse = ActCourseService.getActCourse();

        vm.showDialog = function (dialog) {
            vm[dialog] = true;
        };

        vm.hideDialog = function (dialog) {
            vm[dialog] = false;
        };

        vm.attendeeList = [];

        vm.hotelList = [];
        vm.loadHotelList = function () {
            vm.hotelList = [];
            APIs.CourseHotelService.query({ course: vm.selectedCourse.id }).$promise.then(function (data) {
                angular.forEach(data, function (courseHotel) {
                    vm.hotelList.push(courseHotel);
                });
                vm.loadHotelRooms();
            });
        };

        vm.hotelRooms = [];
        vm.loadHotelRooms = function () {
            APIs.HotelRoomService.query().$promise.then(function (hrs) {
                vm.hotelRooms = [];
                angular.forEach(hrs, function (hr) {
                    vm.hotelRooms.push(hr);
                });
                vm.loadHotelRoomAttendees();
            });
        };

        vm.loadHotelRoomAttendees = function () {
            APIs.HotelRoomAttendeesService.query({ hotel_room__hotel__course: vm.selectedCourse.id }).$promise.then(function (hra) {
                angular.forEach(hra, function (hra) {
                    var a = BasicService.filter('filter')(vm.attendeeList, { id: hra.attendee }, true);
                    var hr = BasicService.filter('filter')(vm.hotelRooms, { id: hra.hotel_room }, true);
                    var h = BasicService.filter('filter')(vm.hotelList, { id: hr[0].hotel }, true);
                    a[0].hotel_room = angular.copy(hr[0]);
                    a[0].hotel_room.hotel = h[0].hotel;
                });
                vm.tableParams.settings({
                    dataset: vm.attendeeList
                });
                vm.tableParams.page(1);
            });
        };

        vm.loadData4Checkin = function () {
            APIs.AttendeeService.query({ course: vm.selectedCourse.id }).$promise.then(function (data) {
                angular.forEach(data, function (attendee) {
                    vm.attendeeList.push({ id: attendee.id, attendee: attendee, hotel_room: null });
                });
                vm.loadHotelList();
            });
        };

        if (angular.isDefined(vm.selectedCourse) && vm.selectedCourse !== null) {
            vm.loadData4Checkin();
        }

        vm.cols = [
            { valueExpr: 'attendee.attendee.person.name', title: 'Name', sortable: 'attendee.person.name', filter: { 'attendee.person.name': 'text' }, show: true },
            { valueExpr: 'attendee.attendee.person.first_name', title: 'Vorname', sortable: 'attendee.person.first_name', filter: { 'attendee.person.first_name': 'text' }, show: true },
            { valueExpr: 'attendee.attendee.type', title: 'Art', sortable: 'type', filter: { 'attendee.type': 'select' }, filterData: ConfigService.ATTENDEE_TYPE, show: true },
            { valueExpr: 'attendee.attendee.need_lift_pass | liftPassFilter', title: 'Liftkarte', show: true },
            { valueExpr: 'attendee.hotel_room.hotel.name', title: 'Hotel', filter: { 'hotel_room.hotel.name': 'text' }, show: true },
            { valueExpr: 'attendee.hotel_room.room', title: 'Zimmer', filter: { 'hotel_room.room': 'text' }, show: true },
            { field: 'action', title: '', dataType: 'command', filter: { 'attendee.present': 'select' }, filterData: [{ id: true, title: 'anwesend' }, { id: false, title: 'abwesend' }] }
        ];

        vm.tableParams = new ConfigService.NgTableParams({ page: 1, count: 10, sorting: { 'attendee.person.name': 'asc', 'attendee.person.first_name': 'asc' } }, {
            defaultSelectValue: 'Show all',
            dataset: vm.attendeeList
        });

        vm.setSelected = function (attendee) {
            vm.selectedAttendee = attendee;
        };

        vm.updateAttendee = function (data) {
            var a = BasicService.filter('filter')(vm.attendeeList, { id: data.id }, true);
            a[0].attendee = data;
            vm.selectedAttendee = a[0];
            vm.tableParams.settings({
                dataset: vm.attendeeList
            });
        };

        vm.attendeeCheckin = function (attendee) {
            var a = angular.copy(attendee.attendee);
            a.present = !a.present;
            APIs.AttendeeService.update(a, function (data) {
                vm.updateAttendee(data);
            });
        };

        vm.attendeePriceChange = function (attendee, text) {
            var a = angular.copy(attendee.attendee);
            a.need_lift_pass = !a.need_lift_pass;
            if (angular.isUndefined(a.remark_lift_pass) || a.remark_lift_pass.length === 0) {
                a.remark_lift_pass = text;
            } else {
                a.remark_lift_pass = a.remark_lift_pass + '; ' + text;
            }
            APIs.AttendeeService.update(a, function (data) {
                vm.updateAttendee(data);
                vm.hideDialog('showAttendeePrice');
            });
        };
    });
